import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { motion as m } from "framer-motion"
import UsefetchCollectionNonRealtime from "../Componentslogic/UsefetchcollectionNonrealtime"
import {
  FILTER_BY_SEARCH_ADMIN,
  SelectFilteredAdmin,
} from "../../redux/actions/FilterProducts"
import Modal from "react-modal"
import CreateproductHook from "../Componentslogic/productsLogic/CreateproductHook"
import CreatecategoryHook from "../Componentslogic/categoriesLogic/CreatecategoryHook"
import ReactSelect from "react-select"
import "../../Styles/EditProducts.css"
import Form from "react-bootstrap/Form"
import {
  doc,
  updateDoc,
  addDoc,
  collection,
  Timestamp,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/config"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import Notify from "../Componentslogic/Usenotifications"
import { AdminMobilemenucard } from "./MobileProductCard"
Modal.setAppElement("#root")

const AdminMobilemenucontainer = () => {
  const { data: initialProducts } = UsefetchCollectionNonRealtime("Products")

  const { data: categories } = UsefetchCollectionNonRealtime("Categories")
  const { data: orders } = UsefetchCollectionNonRealtime("Orders")
  const [searchword, setSearchword] = useState("")
  const [isAddProductModalOpen, setAddProductModalOpen] = useState(false)
  const [products, setProducts] = useState([])
  const [editSizes, setEditSizes] = useState([])
  const [isAddCategoryModalOpen, setAddCategoryModalOpen] = useState(false)
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [catId, setCategoryId] = useState("")
  const [catName, setCategoryName] = useState("")
  const [priceBefore, setPricebefore] = useState("")
  const [sizes, setSizes] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedCategoryImage, setSelectedCategoryImage] = useState(null)
  const [categoriesList, setCategoriesList] = useState([])
  const [productImage, setProductImage] = useState(null)
  const [editProductImage, setEditProductImage] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [sortOption, setSortOption] = useState({
    value: "highest",
    label: "Highest to Lowest (Purchased)",
  })
  const [isEditProductModalOpen, setEditProductModalOpen] = useState(false)
  const [editProduct, setEditProduct] = useState(null)
  const [showSearch, setShowSearch] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const itemsPerPage = 1
  const [currentPage, setCurrentPage] = useState(1)

  const handleAddSize = () => {
    setSizes([...sizes, { size: "", Price: 0 }])
  }

  useEffect(() => {
    if (editProduct) {
      setEditSizes(editProduct.sizes || [])
    }
  }, [editProduct])

  const handleSizeChange = (index, key, value) => {
    const updatedSizes = [...sizes]
    updatedSizes[index][key] = key === "Price" ? parseFloat(value) || 0 : value
    setSizes(updatedSizes)
  }
  const handleEditSizeChange = (index, key, value) => {
    setEditSizes((prevSizes) => {
      const updatedSizes = [...prevSizes]
      updatedSizes[index] = {
        ...updatedSizes[index],
        [key]: key === "Price" ? parseFloat(value) || 0 : value,
      }
      return updatedSizes
    })
  }
  const handleRemoveEditSize = (index) => {
    const updatedSizes = [...editSizes]
    updatedSizes.splice(index, 1)
    setEditSizes(updatedSizes)
  }

  const handleAddEditSize = () => {
    setEditSizes([...editSizes, { size: "", Price: "" }])
  }

  const handleRemoveSize = (index) => {
    const updatedSizes = [...sizes]
    updatedSizes.splice(index, 1)
    setSizes(updatedSizes)
  }
  const OnchangeName = (e) => {
    setName(e.target.value)
  }
  const OnchangeDescription = (e) => {
    setDescription(e.target.value)
  }
  const OnchangeCatid = (e) => {
    const [catId, catName] = e.target.value.split("|")
    setCategoryName(catName)
    setCategoryId(catId)
  }
  const Onchangepricebefore = (e) => {
    setPricebefore(e.target.value)
  }

  const filteredProducts = useSelector(SelectFilteredAdmin)
  const dispatch = useDispatch()

  const [Catname, , , , inputName] = CreatecategoryHook()

  const handleAddCategory = async (e) => {
    e.preventDefault()
    // Ensure category name and image are provided
    if (!Catname.trim()) {
      alert("Please enter a category name!")
      return
    }

    const categoryData = {
      name: Catname,
      createdAt: Timestamp.now().toDate(),
    }

    try {
      await addDoc(collection(db, "Categories"), categoryData)

      Notify("Category added successfully!", "success")
      setSelectedCategoryImage(null)
      setAddCategoryModalOpen(false)
    } catch (error) {
      console.error("Error saving category:", error)
      alert("Failed to add category!")
    }
  }

  useEffect(() => {
    if (categories) {
      setCategoriesList(categories) // Sync categories from Firestore to local state
    }
  }, [categories])

  useEffect(() => {
    if (initialProducts && orders) {
      // Calculate purchase counts
      const enrichedProducts = initialProducts.map((product) => {
        const purchaseCount = orders.reduce((total, order) => {
          const cartItems = order.cartItems || []
          const matchingItem = cartItems.find(
            (item) => item.name === product.name
          )
          return total + (matchingItem?.CartTotalQuantity || 0)
        }, 0)

        return { ...product, purchaseCount } // Add purchaseCount to each product
      })

      setProducts(enrichedProducts)
    }
  }, [initialProducts, orders])

  const handleImageChange = (e, isEdit = false) => {
    if (isEdit) {
      setEditProductImage(e.target.files[0])
    } else {
      setProductImage(e.target.files[0])
    }
  }

  const uploadImage = async (imageFile) => {
    if (!imageFile) return null
    const storageRef = ref(storage, `Products/${imageFile.name}`)
    const uploadTask = uploadBytesResumable(storageRef, imageFile)

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        null,
        (error) => reject(error),
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
          resolve(downloadURL)
        }
      )
    })
  }

  const handleSubmitproductImage = async (e) => {
    e.preventDefault()
    let imageUrl = ""
    if (productImage) {
      imageUrl = await uploadImage(productImage)
    }

    const productData = {
      name,
      description,
      Price: parseFloat(priceBefore),
      CategoryId: catId,
      CategoryName: catName,
      sizes: sizes.filter((size) => size.size && size.Price),
      imageUrl,
      createdAt: Timestamp.now().toDate(),
    }

    try {
      // Add product to Firestore
      const docRef = await addDoc(collection(db, "Products"), productData)
      // Get Firestore-generated ID
      const newProduct = { id: docRef.id, ...productData }
      setProducts((prevProducts) => [newProduct, ...prevProducts])
      Notify("Product added successfully!", "success")
      setName("")
      setDescription("")
      setCategoryId("")
      setCategoryName("")
      setPricebefore("")
      setSelectedCategory(null)
      setSizes([])
      setProductImage(null)
      handleAddProductModalClose()
    } catch (error) {
      Notify("Error Adding product !", "error")
      setSelectedCategory(null)
      setCategoryId("")
      setCategoryName("")
      handleAddProductModalClose()
    }
  }

  useEffect(() => {
    if (products.length > 0) {
      let filtered = [...products]

      // ✅ Filter by selected category
      if (selectedCategory && selectedCategory.value !== "all") {
        filtered = filtered.filter(
          (product) => product.CategoryId === selectedCategory.value
        )
      }

      // ✅ Sorting logic
      if (sortOption) {
        filtered.sort((a, b) => {
          switch (sortOption.value) {
            case "highest":
              return b.purchaseCount - a.purchaseCount // 🔹 Most purchased first
            case "lowest":
              return a.purchaseCount - b.purchaseCount // 🔹 Least purchased first
            case "priceHighest":
              return b.Price - a.Price // 🔹 Highest price first
            case "priceLowest":
              return a.Price - b.Price // 🔹 Lowest price first
            default:
              return 0
          }
        })
      }

      // ✅ Filter by search term
      if (searchword.trim() !== "") {
        filtered = filtered.filter((product) =>
          product.name.toLowerCase().includes(searchword.toLowerCase())
        )
      }

      // ✅ Update Redux store with sorted & filtered products
      dispatch(FILTER_BY_SEARCH_ADMIN({ searchword, data: filtered }))
    }
  }, [products, searchword, selectedCategory, sortOption, dispatch])

  const handleAddProductModalClose = () => setAddProductModalOpen(false)
  const handleAddCategoryModalClose = () => setAddCategoryModalOpen(false)

  const categoryOptions = [
    { value: "all", label: "All" },
    ...categories?.map((category) => ({
      value: category.id,
      label: category.name,
    })),
  ]

  const sortOptions = [
    { value: "highest", label: "Highest to Lowest (Purchased)" },
    { value: "lowest", label: "Lowest to Highest (Purchased)" },
    { value: "priceHighest", label: "Price: Highest to Lowest" },
    { value: "priceLowest", label: "Price: Lowest to Highest" },
  ]

  const handleEditProduct = (product) => {
    setEditProduct({ ...product })
    if (product.CategoryId && product.CategoryName) {
      setSelectedCategory({
        value: product.CategoryId,
        label: product.CategoryName,
      })
      setEditProductModalOpen(true)
    }
  }
  const handleUpdateProduct = async (e) => {
    e.preventDefault()
    try {
      let imageUrl = editProduct.imageUrl || ""
      if (editProductImage) {
        imageUrl = await uploadImage(editProductImage) // Upload new image if changed
      }
      const productDocRef = doc(db, "Products", editProduct.id)

      const updatedProduct = {
        ...editProduct,
        sizes: editSizes.map((size) => ({
          ...size,
          Price: parseFloat(size.Price) || 0,
        })),
        Price: parseFloat(editProduct.Price) || 0,
        imageUrl,
      }
      await updateDoc(productDocRef, updatedProduct)
      setProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.id === updatedProduct.id ? updatedProduct : product
        )
      )
      Notify("Product updated successfully!", "success")
      setSelectedCategory(null)
      setCategoryId("")
      setCategoryName("")
      setEditProductModalOpen(false)
    } catch (error) {
      Notify("Error Updating!", "error")
      setSelectedCategory(null)
      setCategoryId("")
      setCategoryName("")
      setEditProductModalOpen(false)
    }
  }
  const handleDeleteProduct = (productId) => {
    setProducts((prevProducts) =>
      prevProducts.filter((product) => product.id !== productId)
    )
  }

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentProducts = filteredProducts.slice(
    indexOfFirstItem,
    indexOfLastItem
  )

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage)

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <header className="mobile-dashboard-header">
        <h2 className="title" style={{ color: "black" }}>
          All Products
        </h2>
        <div className="mobile-actions-container-Products mt-5 mb-3">
          <button
            className="mobile-action-btn-employee"
            onClick={() => setAddProductModalOpen(true)}
          >
            Add Product
          </button>
          <button
            className="mobile-action-btn-employee"
            onClick={() => setAddCategoryModalOpen(true)}
          >
            Add Category
          </button>
          <button
            className="mobile-action-btn-employee"
            onClick={() => setShowFilters(!showFilters)}
          >
            Filter
          </button>
          <button
            className="mobile-action-btn-employee"
            onClick={() => setShowSearch(!showSearch)}
          >
            Search
          </button>
        </div>
        {/* Search Bar (Toggles On/Off) */}
        {showSearch && (
          <div className="mobile-search-bar">
            <input
              type="text"
              placeholder="Search Products..."
              value={searchword}
              onChange={(e) => setSearchword(e.target.value)}
              className="mobile-search-input"
            />
          </div>
        )}

        {/* Filter Options (Toggles On/Off) */}
        {showFilters && (
          <div className="mobile-filters">
            <ReactSelect
              options={categoryOptions}
              onChange={(option) => setSelectedCategory(option)}
              value={selectedCategory}
              placeholder="Filter by Category"
            />
            <ReactSelect
              options={sortOptions}
              onChange={(option) => setSortOption(option)}
              value={sortOption}
              placeholder="Sort"
            />
          </div>
        )}
      </header>
      <div className="pagination-controls mb-3">
        <span className="pagination-info">
          Page {currentPage} of {totalPages || 1}
        </span>

        <button
          className="pagination-btn "
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1} // Disable when on the first page
        >
          &#8592;
        </button>

        <button
          className="pagination-btn "
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage >= totalPages} // Disable when on the last page
        >
          &#8594;
        </button>
      </div>

      <div className="mobile-orders-container justify-content-center">
        {currentProducts ? (
          currentProducts.map((product, index) => (
            <AdminMobilemenucard
              key={index}
              products={product}
              onEdit={() => handleEditProduct(product)}
              onDelete={handleDeleteProduct}
            />
          ))
        ) : (
          <h3>No data to view</h3>
        )}
      </div>

      {/* Add Product Modal */}
      <Modal
        isOpen={isAddProductModalOpen}
        onRequestClose={handleAddProductModalClose}
        contentLabel="Add Product"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            overflow: "auto",
          },
          content: {
            position: "static",
            inset: "unset",
            width: "700px",
            height: "fit-content",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
      >
        <h4 className="modal-title">Add Product</h4>
        <form
          onSubmit={(e) => handleSubmitproductImage(e)}
          style={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <div className="form-group">
            <label>Product Name </label>
            <input
              type="text"
              value={name}
              onChange={OnchangeName}
              className="form-input"
              required
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              onChange={OnchangeDescription}
              value={description}
              name="Name"
              placeholder="Add Product description"
              type="text"
              className="form-input"
              rows="3"
            />
          </div>
          <div className="form-group">
            <label>Category</label>
            <Form.Select
              onChange={OnchangeCatid}
              value={catId ? `${catId}|${catName}` : ""}
              className="input-Prod"
            >
              <option value="">Please select a category</option>
              {categoriesList?.map((category, index) => (
                <option key={index} value={`${category.id}|${category.name}`}>
                  {category.name}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="form-group">
            <label>Sizes (Optional)</label>
            {sizes.map((size, index) => (
              <div key={index} className="d-flex align-items-center gap-2 mb-2">
                <input
                  type="text"
                  placeholder="Size Name (e.g., Small)"
                  value={size.size}
                  onChange={(e) =>
                    handleSizeChange(index, "size", e.target.value)
                  }
                  className="form-input"
                />
                <input
                  type="number"
                  placeholder="Price (EGP)"
                  value={size.Price}
                  onChange={(e) =>
                    handleSizeChange(index, "Price", e.target.value)
                  }
                  className="form-input"
                />
                <button
                  onClick={() => handleRemoveSize(index)}
                  className="btns-Admin"
                >
                  ❌
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={handleAddSize}
              className="btns-Admin"
            >
              + Add Size
            </button>
          </div>
          <div className="form-group">
            <label>Price</label>
            <input
              type="number"
              value={priceBefore}
              onChange={Onchangepricebefore}
              className="form-input"
              required
            />
          </div>

          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(e)}
          />

          <div className="modal-actions">
            <button className="btn-submit" type="submit" disabled={uploading}>
              {uploading ? "Uploading..." : "Add"}
            </button>
            <button
              type="button"
              onClick={handleAddProductModalClose}
              className="btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>

      {/* Add Category Modal */}
      <Modal
        isOpen={isAddCategoryModalOpen}
        onRequestClose={() => setAddCategoryModalOpen(false)}
        contentLabel="Add Category"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
          },
          content: {
            position: "static",
            inset: "unset",
            width: "400px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
      >
        <h4 className="modal-title">Add Category</h4>
        <form onSubmit={handleAddCategory}>
          <div className="form-group">
            <label>Category Name</label>
            <input
              type="text"
              value={Catname}
              onChange={inputName}
              className="form-input"
              required
            />
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn-submit">
              Add
            </button>
            <button
              type="button"
              onClick={() => setAddCategoryModalOpen(false)}
              className="btn-cancel"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEditProductModalOpen}
        onRequestClose={() => setEditProductModalOpen(false)}
        contentLabel="Edit Product"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            overflow: "auto",
          },
          content: {
            position: "static",
            inset: "unset",
            width: "700px",
            height: "fit-content",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            backgroundColor: "#fff",
          },
        }}
      >
        <h4 className="modal-title">Edit Product</h4>
        {editProduct && (
          <form
            onSubmit={handleUpdateProduct}
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            <div className="form-group">
              <label>Product Name</label>
              <input
                type="text"
                value={editProduct.name}
                onChange={(e) =>
                  setEditProduct((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
                className="form-input"
                required
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={editProduct.description}
                onChange={(e) =>
                  setEditProduct((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
                className="form-input"
                rows="3"
                required
              />
            </div>
            <div className="form-group">
              <Form.Select
                value={
                  editProduct?.CategoryId && editProduct?.CategoryName
                    ? `${editProduct.CategoryName}`
                    : ""
                }
                onChange={(e) => {
                  const [catId, catName] = e.target.value.split("|")
                  setEditProduct((prev) => ({
                    ...prev,
                    CategoryId: catId,
                    CategoryName: catName,
                  }))
                }}
                className="input-Prod"
              >
                <option>{editProduct.CategoryName}</option>
                {categoriesList?.map((category, index) => (
                  <option key={index} value={`${category.id}|${category.name}`}>
                    {category.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/* Size Editing Fields */}
            <div className="form-group">
              {editSizes.map((size, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-2 mb-2"
                >
                  <input
                    type="text"
                    placeholder="Size Name"
                    value={size.size}
                    onChange={(e) =>
                      handleEditSizeChange(index, "size", e.target.value)
                    }
                    className="form-input"
                  />
                  <input
                    type="number"
                    placeholder="Price (EGP)"
                    value={size.Price}
                    onChange={(e) =>
                      handleEditSizeChange(index, "Price", e.target.value)
                    }
                    className="form-input"
                  />
                  <button
                    onClick={() => handleRemoveEditSize(index)}
                    className="btns-Admin"
                  >
                    ❌
                  </button>
                </div>
              ))}
              <button
                type="button"
                onClick={handleAddEditSize}
                className="btns-Admin"
              >
                + Add Size
              </button>
            </div>

            <div className="form-group">
              <label>Price</label>
              <input
                type="number"
                value={editProduct.Price}
                onChange={(e) =>
                  setEditProduct((prev) => ({
                    ...prev,
                    Price: e.target.value,
                  }))
                }
                className="form-input"
                required
              />
            </div>
            <img src={editProduct.imageUrl} alt="Product" width="100" />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, true)}
            />

            <div className="modal-actions">
              <button className="btn-submit" type="submit" disabled={uploading}>
                {uploading ? "Uploading..." : "Update"}
              </button>
              <button
                type="button"
                onClick={() => setEditProductModalOpen(false)}
                className="btn-cancel"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </Modal>
    </m.div>
  )
}

export default AdminMobilemenucontainer
